import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function ApplicationReducer(state = initialState.application, action: any) {
  switch (action.type) {
    case types.SAVE_APPLICATION_SUCCESS:
      return action.application;
    default:
      return state;
  }
}
